import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { PainPoints } from '../components/PainPoints';
import { Solution } from '../components/Solution';
import { CourseModules } from '../components/CourseModules';
import { PDFLibrary } from '../components/PDFLibrary';
import { Testimonials } from '../components/Testimonials';
import { Bonuses } from '../components/Bonuses';
import { FAQ } from '../components/FAQ';
import { Pricing } from '../components/Pricing';
import { Guarantee } from '../components/Guarantee';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { SalesNotification } from '../components/SalesNotification';
import { CTAButton } from '../components/CTAButton';
export function LandingPage() {
  return <main className="min-h-screen w-full bg-[#FDFBF7] font-sans text-[#3D3028] selection:bg-[#E5A5A0] selection:text-white" data-id="element-400">
      <Header data-id="element-401" />
      <Hero data-id="element-402" />
      <PainPoints data-id="element-403" />
      <CTAButton data-id="element-404" />
      <Solution data-id="element-405" />
      <CTAButton data-id="element-406" />
      <CourseModules data-id="element-407" />
      <CTAButton data-id="element-408" />
      <PDFLibrary data-id="element-409" />
      <Testimonials data-id="element-410" />
      <CTAButton data-id="element-411" />
      <Bonuses data-id="element-412" />
      <CTAButton data-id="element-413" />
      <FAQ data-id="element-414" />
      <Pricing data-id="element-415" />
      <Guarantee data-id="element-416" />
      <FinalCTA data-id="element-417" />
      <Footer data-id="element-418" />
      <SalesNotification data-id="element-419" />
    </main>;
}